import React from 'react';
import OperatorListingBody from './OperatorListingBody';

const OperatorListing = (props) => {
    return (
        <table className="listingTableSection">
            <thead className="desktopOnly tableHeading">
                <tr className="makeFlex">
                    <th style={{ paddingLeft: "16px", width: "500px" }} align="left">Routes</th>
                    <th style={{ width: "416px" }} align="left">Available Bus Types</th>
                    <th style={{ width: "216px" }} align="left">Price</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <OperatorListingBody  {...props} />
            </tbody>
        </table>
    )
}

export default OperatorListing;
